import { render, staticRenderFns } from "./frontBackaAppraisal_tea.vue?vue&type=template&id=1912d190&scoped=true&"
import script from "./frontBackaAppraisal_tea.vue?vue&type=script&lang=js&"
export * from "./frontBackaAppraisal_tea.vue?vue&type=script&lang=js&"
import style0 from "./frontBackaAppraisal_tea.vue?vue&type=style&index=0&id=1912d190&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1912d190",
  null
  
)

export default component.exports